import { ErrorType, ModelError } from 'src/front/api/generated';

import {
  CAPTCHA_ERROR_CODE,
  ERR_ESKI_SIFRE,
  ERR_KISA_SIFRE,
  ERR_SIFRE_HATA,
  ERR_SIFRE_NUMERIK,
  ERR_SIFRE_TEKRAR,
  ERR_YENI_SIFRE,
  INVALID_FILE_ERROR,
  INVALID_INN_NUMBER,
  INVALID_SESSION_ERROR_CODE,
  INVALID_TAX_NUMBER,
  JWT_ERROR_CODE,
  LOGIN_ERROR_CODES,
  MISSING_INN_NUMBER,
} from 'src/front/constant';

const isCaptchaError = ({ errorType, errorID }: ModelError): boolean =>
  errorType === ErrorType.MIDDLEWAREERROR && errorID === CAPTCHA_ERROR_CODE;

const isLoginError = ({ errorID = 0, errorType }: ModelError): boolean =>
  LOGIN_ERROR_CODES.includes(errorID) && errorType === ErrorType.AUTHENTICATIONERROR;

export const isPreLoginError = (error: ModelError): boolean => {
  return isCaptchaError(error) || isLoginError(error);
};

export const isSessionEndingError = ({ errorID, errorType }: ModelError): boolean => {
  return (
    (errorID === JWT_ERROR_CODE && errorType === ErrorType.AUTHENTICATIONERROR) ||
    (errorID === INVALID_SESSION_ERROR_CODE && errorType === ErrorType.MIDDLEWAREERROR)
  );
};
export const isInvalidFileError = ({ errorID, errorType }: ModelError): boolean => {
  return errorID === INVALID_FILE_ERROR && errorType === ErrorType.MIDDLEWAREERROR;
};

export const isInvalidTaxNumber = ({ errorID, errorType }: ModelError): boolean => {
  return errorID === INVALID_TAX_NUMBER && errorType === ErrorType.COREERROR;
};

export const isIncorrectInnNumber = ({ errorID, errorType }: ModelError): boolean => {
  return (
    (errorID === INVALID_INN_NUMBER && errorType === ErrorType.COREERROR) ||
    (errorID === MISSING_INN_NUMBER && errorType === ErrorType.COREERROR)
  );
};

export const isPasswordCorrect = ({ errorID, errorType }: ModelError): boolean => {
  return (
    (errorID === ERR_SIFRE_NUMERIK && errorType === ErrorType.COREERROR) ||
    (errorID === ERR_SIFRE_TEKRAR && errorType === ErrorType.COREERROR) ||
    (errorID === ERR_ESKI_SIFRE && errorType === ErrorType.COREERROR) ||
    (errorID === ERR_KISA_SIFRE && errorType === ErrorType.COREERROR) ||
    (errorID === ERR_YENI_SIFRE && errorType === ErrorType.COREERROR) ||
    (errorID === ERR_SIFRE_HATA && errorType === ErrorType.COREERROR)
  );
};

export const isIgnoredError = ({ errorID, errorType }: ModelError): boolean => {
  return (
    isInvalidFileError({ errorID, errorType }) ||
    isInvalidTaxNumber({ errorID, errorType }) ||
    isIncorrectInnNumber({ errorID, errorType }) ||
    isPasswordCorrect({ errorID, errorType })
  );
};

export const getRejectReason = (errorResponse: any): any => {
  const { data } = errorResponse.response;
  return isIgnoredError(data?.error) ? data?.error : errorResponse;
};
